import { SVGProps } from 'react';

export const CheckListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='20'
    height='21'
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M3.22815 5.75657L3.98358 6.512C4.11413 6.64255 4.3236 6.64912 4.4621 6.527L6.23627 4.47266'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.22815 10.8132L3.98358 11.5686C4.11413 11.6992 4.3236 11.7058 4.4621 11.5836L6.23627 9.5293'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.22815 15.6706L3.98358 16.4261C4.11413 16.5566 4.3236 16.5632 4.4621 16.4411L6.23627 14.3867'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.5133 5.54297H16.7718'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.5133 10.5996H16.7718'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.5133 15.457H16.7718'
      strokeWidth='1.27'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
